import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/contents/provider-referral")({
  beforeLoad: () => {
    throw redirect({ to: "/saint-for-clinicians" });
  },
});
